{
  "errors": {
    "failedToLoad": "Failed to load own data",
    "unexpectedError": "An unexpected error occurred",
    "updateFailed": "Failed to update contact details. Please try again later."
  },
  "contractDocument": {
    "header": "Contract",
    "errors": {
      "failedToOpen": "Failed to open the contract document. Please try again later."
    }
  }
}
